import classNames from 'classnames';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(SBHorizontal).attrs({ gap: 0 })`
  overflow: hidden;
  background: var(--c-nd-50);
  border: 1px solid var(--c-nd-50);
  align-items: stretch;
  padding-left: calc(5 * var(--unit));
  border-radius: var(--double-unit);

  &.highlighted {
    border-color: var(--c-white);
  }
`;
const StepContent = styled(Vertical)`
  flex: 1;
  padding: var(--double-unit);
`;
const ImgWrapper = styled.div`
  aspect-ratio: 1;
  width: 120px;
  height: 120px;

  & > * {
    width: 100%;
    height: 100%;
  }
`;

type Props = {
  title?: ReactNode;
  subtitle?: ReactNode;
  img?: ReactNode;
  highlighted?: boolean;
};
export const Step = ({ title, subtitle, img, highlighted }: Props) => {
  return (
    <Root className={classNames({ highlighted })}>
      <StepContent>
        {title}
        {subtitle}
      </StepContent>
      <ImgWrapper>{img}</ImgWrapper>
    </Root>
  );
};
